import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Lx } from '../../../../i18n/consts';
import ProfileInfoCard from '../profile-info-card';
import styles from '../../profile.module.scss';
import ProfileTabPage from '../profile-tab-page';
import { useProfileData } from '../../hooks/useProfileData';

const ProfileInfoPage = () => {
    const intl = useIntl();
    const { profile, loading } = useProfileData();

    const infoCards = useMemo(() => ([
        {
            key: 'name',
            labelId: Lx.General.USER,
            value: profile.name,
        },
        {
            key: 'workspace',
            labelId: Lx.General.WORKSPACE,
            value: profile.workspaceName,
        },
        {
            key: 'email',
            labelId: Lx.General.EMAIL,
            value: profile.email,
        },
        {
            key: 'phone',
            labelId: Lx.General.PHONENUMBER,
            value: profile.phoneNumber,
        },
        {
            key: 'position',
            labelId: Lx.Employee.POSITION,
            value: profile.position,
        }
    ]), [profile.email, profile.name, profile.phoneNumber, profile.position, profile.workspaceName]);

    const emptyValueLabel = intl.formatMessage({ id: Lx.General.NOT_AVAILABLE });

    return (
        <ProfileTabPage activeTab={'profile'} loading={loading}>
            <div className={styles.profileCardLayout}>
                <div className={styles.profileCards}>
                    {infoCards.map(card => (
                        <ProfileInfoCard
                            key={card.key}
                            labelId={card.labelId}
                            value={card.value}
                            emptyValue={emptyValueLabel}
                        />
                    ))}
                </div>
            </div>
        </ProfileTabPage>
    )
}

export default React.memo(ProfileInfoPage);
